export enum GroupAccess {
  OPEN = "write",
  INTERNAL = "read",
  CONFIDENTIAL = "hidden",
}
